import { SearchCriteria } from "./search-criteria";

export class GetClientInfoSearchCriteria extends SearchCriteria {

}
